/**
 * @file useLatestRequest.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-29
 * @modified 2026-09-29
 *
 * Only the newest request may write the results.
 *
 * A search box fires a request per pause in typing, and the responses do not
 * come back in order: a slow "burc" landing after a quick "burcombe" put the
 * wrong rows under the text in the box. Take a ticket before the fetch and
 * check it after:
 *
 *   const latest = useLatestRequest();
 *   const ticket = latest.begin();
 *   const data = await (await fetch(url)).json();
 *   if (!latest.isLatest(ticket)) return;   // superseded
 */

import { useMemo, useRef } from 'react';

export default function useLatestRequest() {
  const seq = useRef(0);
  return useMemo(() => ({
    begin: () => ++seq.current,
    isLatest: (ticket) => ticket === seq.current
  }), []);
}
